import React from 'react';
import {Typography} from '@mui/material';

export const PaymentDetailsHeading = ({description}: {description: string}) => <>
    <Typography variant="h5">Payment Details</Typography>
    <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>{description}</Typography>
</>;
